/**
 * Frontend mirror of the backend's `server/contract-review/configs.ts` registry.
 *
 * Source of truth for the contract-type dropdown. Entries with
 * `available: false` render disabled ("coming soon") — they're a visible
 * roadmap, not aspirational vapor.
 *
 * To add a new contract type:
 *   1. Add the backend prompt + config (see server/contract-review/README.md).
 *   2. Add the matching entry below with `available: true`.
 *
 * The `id` must match the backend's ContractType id exactly.
 */

export type ContractTypeOption = {
  id: string;
  /** Short name shown in the dropdown */
  label: string;
  /** Long form used in the run-button label and download notification */
  longLabel: string;
  available: boolean;
};

export const CONTRACT_TYPES: ContractTypeOption[] = [
  {
    id: "ppa",
    label: "PPA",
    longLabel: "Power Purchase Agreement",
    available: true,
  },
  {
    id: "lcca",
    label: "LCCA",
    longLabel: "LLC Agreement (Tax Equity)",
    available: true,
  },
  {
    id: "depositary",
    label: "Depositary Agreement",
    longLabel: "Depositary Agreement",
    available: false,
  },
  {
    id: "credit",
    label: "Credit Agreement",
    longLabel: "Credit Agreement",
    available: false,
  },
];

export function findContractType(id: string): ContractTypeOption | undefined {
  return CONTRACT_TYPES.find((t) => t.id === id);
}
